import routeNames from "../../router/routeNames"

const navLinks = [
   {
      path: routeNames.PROFILE,
      icon: '/assets/icons/profile-link-icon.svg',
      label: 'Профиль'
   },
   {
      path: routeNames.MESSENGERS,
      icon: '/assets/icons/messengers-link-icon.svg',
      label: 'Мессенджеры'
   },
   {
      path: routeNames.CRM,
      icon: '/assets/icons/crm-link-icon.svg',
      label: 'CRM'
   },
   {
      path: routeNames.PLAN,
      icon: '/assets/icons/plan-link-icon.svg',
      label: 'Покупка тарифа'
   }
]

export default navLinks